import { ProgressBar, Text2, Text5, Text6, skinVars } from '@telefonica/mistica';
import './index.scss';
import { useTranslation } from 'react-i18next';
import { conversionToGB } from '../../utils/dataTransformation/unitsConversion';
import { useEffect, useMemo, useState } from 'react';

export interface IExtraMobileConvergent {
    dataSharing?: boolean;
    data?: any;
    isBonus: boolean;
    isBadge: boolean;
    isBlocked: boolean;
}
const ExtraMobileConvergent: React.FC<IExtraMobileConvergent> = ({ data, isBlocked }: IExtraMobileConvergent) => {
    const { t } = useTranslation();
    const percent = Math.round((data?.current * 100) / data?.max);

    const [windowWidth, setWindowWidth] = useState<any>(window.innerWidth);

    const colorTextGB = useMemo(() => {
        let aux;
        if (percent >= 80 && percent <= 99) {
            aux = skinVars.colors.warningHigh;
        } else if (percent >= 100) {
            aux = skinVars.colors.errorHigh;
        } else if (percent < 80) {
            aux = skinVars.colors.textPrimary;
        }
        return aux;
    }, [percent]);

    const colorProgressBar = useMemo(() => {
        if (isBlocked) {
            return skinVars.colors.neutralMedium;
        } else if (percent >= 80 && percent <= 99) {
            return skinVars.colors.warning;
        } else if (percent >= 100) {
            return skinVars.colors.errorHigh;
        } else if (percent < 80) {
            return skinVars.colors.success;
        }
    }, [percent, isBlocked]);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    return (
        <div className='boxed-row-mobile'>
            {windowWidth < 768 ? (
                <div>
                    <Text6 color={colorTextGB}>
                        {conversionToGB(data?.unit, data?.current, 2)}
                        <Text2 regular color={skinVars.colors.textSecondary}>
                            {' ' + t('of') + ` ${conversionToGB(data?.unit, data?.max, 0)} `}
                        </Text2>
                    </Text6>
                </div>
            ) : (
                <div>
                    <Text5 color={colorTextGB}>
                        {conversionToGB(data?.unit, data?.current, 2)}
                        <Text2 regular color={skinVars.colors.textSecondary}>
                            {' ' + t('of') + ` ${conversionToGB(data?.unit, data?.max, 0)} `}
                        </Text2>
                    </Text5>
                </div>
            )}

            <div style={{ marginTop: '8px' }}>
                <ProgressBar color={colorProgressBar} progressPercent={percent} />
            </div>
        </div>
    );
};

export default ExtraMobileConvergent;
